/**
 * Utility function for conditionally joining CSS class names together
 * Based on the original cn function from your project
 */
export const cn = (...classes: (string | boolean | undefined | null)[]): string => {
  return classes.filter(Boolean).join(' ');
};